var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', [_c('h1', [_vm._v("e커머스피칭페스타 지원(뷰)")]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', [_vm._v("라우터 작성시 뷰페이지 "), _c('b', [_vm._v("path")]), _vm._v("에 "), _c('b', [_vm._v(":_id")]), _vm._v(" 설정을 넣어주세요. ")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', [_c('b', [_vm._v("ex)")])]), _c('prism-editor', {
    staticClass: "rounded",
    attrs: {
      "line-numbers": ""
    },
    model: {
      value: _vm.routerExample.code,
      callback: function callback($$v) {
        _vm.$set(_vm.routerExample, "code", $$v);
      },
      expression: "routerExample.code"
    }
  })], 1), _c('div', {
    staticClass: "mt-8"
  }, [_c('b', [_vm._v("23.02.28")])]), _c('div', [_c('b', [_vm._v(" 채연씨 추가 요청) 상세보기, 지원하기 URL, SNS 공유하기, 클립보드 추가")])]), _c('div', [_vm._v(" * 상세보기 레이아웃에 "), _c('b', [_vm._v("id=\"content\"")]), _vm._v(" 추가되어, 버튼 클릭시 이동하는 기능 추가되었습니다.")]), _c('div', [_vm._v(" * 지원하기 링크 추가 되었습니다. ")]), _c('div', [_vm._v(" * SNS 공유하기 버튼 추가되었습니다. ")]), _c('div', [_vm._v(" * 클립보드 복사하기 기능 추가되었습니다. ")]), _c('div', {
    staticClass: "mt-8"
  }, [_c('b', [_vm._v("23.04.17")])]), _c('div', [_c('b', [_vm._v(" 실장님 추가 요청) 공고문 다운로드 기능 추가")])]), _c('div', [_vm._v(" * 상세보기 하단 버튼 목록에 공고문 다운로드 대화상자가 추가 되었습니다.")]), _c('div', [_vm._v(" * "), _c('b', [_vm._v("import download from \"downloadjs\"")]), _vm._v(" 와 "), _c('b', [_vm._v("download: (url, name) => ... ")]), _vm._v(" 함수 추가해주어야 다운로드 기능이 동작합니다. ")]), _c('div', [_vm._v(" * 관리자 > e커머스피칭페스타 지원 > 상세 > 파일 업로드에서 파일 등록가능합니다.")]), _c('example-layout', {
    staticClass: "overflow-auto mt-8",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function fn() {
        return [_c('example-application-view')];
      },
      proxy: true
    }, {
      key: "editor",
      fn: function fn() {
        return [_c('prism-editor', {
          staticClass: "rounded",
          attrs: {
            "line-numbers": ""
          },
          model: {
            value: _vm.example.section_1.code,
            callback: function callback($$v) {
              _vm.$set(_vm.example.section_1, "code", $$v);
            },
            expression: "example.section_1.code"
          }
        })];
      },
      proxy: true
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }